import React, { useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
//i18n
import { withTranslation } from "react-i18next"
import {
  addSlashestoApiNames,
  checkIfSuperAdmin,
  getActiveClass,
  getUrlLastPart,
  hasPermission,
} from "helpers/helpers"

const SidebarContent = props => {
  const { Users } = props
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname || pathName.startsWith(items[i].pathname + "/")) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }
  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            {hasPermission("access-summary") && (
              <li>
                <Link to="/welcome" className={getActiveClass("welcome")}>
                  <i className="bx bx-list-ul"></i>
                  <span>{props.t("Summary")}</span>
                </Link>
              </li>
            )}
            {hasPermission("access-dashboard") && (
              <li>
                <Link to="/dashboard" className={getActiveClass("dashboard")}>
                  <i className="bx bx-home-circle"></i>
                  <span>{props.t("Dashboard")}</span>
                </Link>
              </li>
            )}
            {hasPermission("access-admin") && (
              <li className={getActiveClass("users")}>
                <Link to="/admin/users" className={`has-arrow users `}>
                  <i className="bx bxs-user-detail"></i>
                  <span>{props.t("Admin")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  {Users.map(user => (
                    <li
                      key={user.id}
                      className={getActiveClass(
                        addSlashestoApiNames(user.label)
                      )}
                    >
                      <Link
                        to={`/admin/users?name=${addSlashestoApiNames(
                          user.label
                        )}`}
                      >
                        <i className="bx bx-user"></i>
                        {props.t(user.label)}
                      </Link>
                    </li>
                  ))}
                  {hasPermission("end-users") && (
                    <li>
                      <Link
                        to="/end-users"
                        className={`${getActiveClass("end-users")}`}
                      >
                        <i className="bx bxs-user"></i>
                        <span>{props.t("End Users")}</span>
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-shops") && (
                    <li>
                      <Link
                        to="/admin/shops"
                        className={`${getActiveClass("shops")}`}
                      >
                        <i className="bx bxs-cart"></i>
                        <span>{props.t("Shops")}</span>
                      </Link>
                    </li>
                  )}

                  {hasPermission("read-cashier-role") && (
                    <li>
                      <Link
                        to="/admin/cashiers"
                        className={`${getActiveClass("cashiers")}`}
                      >
                        <i className="bx bx-money"></i>
                        <span>{props.t("Cashiers")}</span>
                      </Link>
                    </li>
                  )}

                  {checkIfSuperAdmin() ? (
                    <>
                      <li>
                        <Link
                          to="/permissions"
                          className={`${getActiveClass("permissions")}`}
                        >
                          <i className="bx bx-lock"></i>
                          <span>{props.t("Permissions")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/roles"
                          className={`${getActiveClass("roles")}`}
                        >
                          <i className="bx bx-user-plus"></i>
                          <span>{props.t("Roles")}</span>
                        </Link>
                      </li>
                    </>
                  ) : null}
                </ul>
              </li>
            )}
            {hasPermission("access-settings-menu") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-cog"></i>
                  <span>{props.t("Settings")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {checkIfSuperAdmin() && hasPermission("read-products") && (
                    <li>
                      <Link to="/products">
                        <i className="bx bx-book-add"></i>
                        {props.t("Products")}
                      </Link>
                    </li>
                  )}
                  {checkIfSuperAdmin() && (
                    <li>
                      <Link to="/access-expiration">
                        <i className="bx bxs-timer"></i>

                        {props.t("Access Expiration")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-operator_products") && (
                    <li>
                      <Link to="/operator-products">
                        <i className="bx bxs-user-detail"></i>

                        {props.t("Operator Products")}
                      </Link>
                    </li>
                  )}

                  {hasPermission("read-supplier_commissions") && (
                    <li>
                      <Link to="/supplier-commissions" className="text-nowrap">
                        <i className="bx bx-money"></i>

                        {props.t("Supplier Commissions")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {hasPermission("access-risk-management-menu") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className=" bx bx-dock-bottom"></i>
                  <span>{props.t("Risk Management")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {hasPermission("read-parameters") && (
                    <li>
                      <Link to="/parameters">
                        <i className="bx bx-list-ul"></i>

                        {props.t("Parameters")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-risk_per_user") && (
                    <li>
                      <Link to="/risk-per-user">
                        <i className=" bx bx-id-card"></i>

                        {props.t("Risk per user")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("access-kyc") && (
                    <li>
                      <Link to="/KYC">
                        <i className=" bx bx-id-card"></i>
                        {props.t("KYC")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {hasPermission("access-accounting-menu") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className=" bx bx-caret-down-circle"></i>
                  <span>{props.t("Accounting")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {hasPermission("read-end_users") && (
                    <li>
                      <Link to="/end-user-accounts">
                        <i className=" bx bx-brain"></i>

                        {props.t("End User Accounts")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-cashier-accounts") && (
                    <li>
                      <Link to="/cashier-accounts">
                        <i className=" bx bx-brain"></i>

                        {props.t("Cashier Accounts")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-deposits") && (
                    <li>
                      <Link to="/deposits">
                        <i className=" bx bx-up-arrow-circle"></i>

                        {props.t("Deposits")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-withdrawals") && (
                    <li>
                      <Link to="/withdrawals">
                        <i className=" bx bx-down-arrow-circle"></i>

                        {props.t("Withdrawals")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {hasPermission("access-reports-menu") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className=" bx bx-message-square-check"></i>
                  <span>{props.t("Reports")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {hasPermission("read-sports-tickets") && (
                    <li>
                      <Link to="/reports/cashout-tickets">
                        <i className="bx bx-medal"></i>

                        {props.t("Cashout Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-sports-tickets") && (
                    <li>
                      <Link to="/reports/sports-tickets">
                        <i className="bx bx-medal"></i>

                        {props.t("Sports Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-book-a-bet-tickets") && (
                    <li>
                      <Link to="/reports/book-a-bet-tickets">
                        <i className="bx bx-medal"></i>

                        {props.t("Book-A-Bet Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-games-tickets") && (
                    <li>
                      <Link to="/reports/games-tickets">
                        <i className="bx bx-game"></i>

                        {props.t("Games Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-games-reports") && (
                    <li>
                      <Link to="/reports/games-reports">
                        <i className="bx bx-game"></i>

                        {props.t("Games Reports")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-jackpot-tickets") && (
                    <li>
                      <Link to="/reports/jackpot-tickets">
                        <i className=" bx bx-gift"></i>

                        {props.t("Jackpot Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-jackpot-report") && (
                    <li>
                      <Link to="/reports/jackpot-report">
                        <i className=" bx bx-gift"></i>

                        {props.t("Jackpot Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-cashier-role") && (
                    <li>
                      <Link to="/reports/cashier-reports">
                        <i className=" bx bx-gift"></i>

                        {props.t("Cashiers Reports")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-shops") && (
                    <li>
                      <Link to="/reports/shop-reports">
                        <i className=" bx bx-gift"></i>

                        {props.t("Shop Reports")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-kiron-report") && (
                    <li>
                      <Link to="/reports/kiron-tickets">
                        <i className=" bx bx-gift"></i>

                        {props.t("Kiron Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-customers-report") && (
                    <li>
                      <Link to="/reports/customers-report">
                        <i className=" bx bx-user"></i>

                        {props.t("Customers Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-bonus-report") && (
                    <li>
                      <Link to="/reports/bonus-report">
                        <i className=" bx bx-dollar-circle"></i>

                        {props.t("Bonus Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-bonus-report") && (
                    <li>
                      <Link to="/reports/multibet-bonus-report">
                        <i className=" bx bx-dollar-circle"></i>

                        {props.t("MultiBet Bonus Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-acca7-report") && (
                    <li>
                      <Link to="/reports/acca7-report">
                        <i className=" bx bx-dollar-circle"></i>

                        {props.t("Acca7 Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-bonus-report") && (
                    <li>
                      <Link to="/reports/bonus-ticket-winning-Report">
                        <i className=" bx bx-dollar-circle"></i>

                        {props.t("Bonus Tickets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-raf-report") && (
                    <li>
                      <Link to="/reports/raf-report">
                        <i className="bx bx-dollar-circle"></i>

                        {props.t("RAF Com Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-mimo-report") && (
                    <li>
                      <Link to="/reports/mimo-report">
                        <i className=" bx bx-money"></i>

                        {props.t("Mimo Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-tax-report") && (
                    <li>
                      <Link to="/reports/tax-report">
                        <i className=" bx bx-spreadsheet"></i>

                        {props.t("Tax Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-suppliers-report") && (
                    <li>
                      <Link to="/reports/suppliers-report">
                        <i className=" bx bx-group"></i>

                        {props.t("Suppliers Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-board-report") && (
                    <li>
                      <Link to="/reports/board-report">
                        <i className=" bx bx-detail"></i>

                        {props.t("Board Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-GGR-report") && (
                    <li>
                      <Link to="/reports/GGR-report">
                        <i className=" bx bx-selection"></i>

                        {props.t("GGR Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-book-a-bet-reports") && (
                    <li>
                      <Link to="/reports/book-a-bet-reports">
                        <i className="bx bx-game"></i>

                        {props.t("Book-A-Bet Reports")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-sms-logs") && (
                    <li>
                      <Link to="/reports/sms-logs">
                        <i className=" bx bx-message"></i>

                        {props.t("SMS Logs")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {hasPermission("access-crm-menu") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-pie-chart"></i>
                  <span>{props.t("CRM")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {hasPermission("read-marketing") && (
                    <li>
                      <Link to="/crm/marketing">
                        <i className="bx bx-news"></i>

                        {props.t("Marketing")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("access-analytics") && (
                    <li>
                      <Link to="/crm/analytics">
                        <i className="bx bx-chart"></i>
                        {props.t("Analytics")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-static-pages") && (
                    <li>
                      <Link to="/crm/static-pages">
                        <i className="bx bx-menu"></i>

                        {props.t("Static Pages")}
                      </Link>
                    </li>
                  )}

                  {hasPermission("read-banners") && (
                    <li>
                      <Link to="/crm/content">
                        <i className="bx bx-spreadsheet"></i>

                        {props.t("Content")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-sports") && (
                    <li>
                      <Link to="/crm/content/sports">
                        <i className="bx bx-spreadsheet"></i>

                        {props.t("Sports")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-locations") && (
                    <li>
                      <Link to="/crm/content/locations">
                        <i className="bx bx-spreadsheet"></i>

                        {props.t("Locations")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-leagues") && (
                    <li>
                      <Link to="/crm/content/leagues">
                        <i className="bx bx-spreadsheet"></i>

                        {props.t("Leagues")}
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link to="/crm/content/special-markets">
                      <i className="bx bx-spreadsheet"></i>

                      {props.t("Special Markets")}
                    </Link>
                  </li>
                  {hasPermission("read-campaigns") && (
                    <li>
                      <Link to="/crm/content/campaigns">
                        <i className="bx bx-spreadsheet"></i>

                        {props.t("Campaigns")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {hasPermission("access-promotions-menu") && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-aperture"></i>
                  <span>{props.t("Promotions")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {hasPermission("read-bonuses") && (
                    <li>
                      <Link to="/promotions/bonuses">
                        <i className="bx bx-bullseye"></i>

                        {props.t("Bonuses")}
                      </Link>
                    </li>
                  )}

                  {hasPermission("read-multibet_bonuses") && (
                    <li>
                      <Link to="/promotions/multibet-bonus">
                        <i className="bx bxs-dollar-circle"></i>

                        {props.t("Multi Bet Bonus")}
                      </Link>
                    </li>
                  )}

                  {hasPermission("read-jackpots") && (
                    <li>
                      <Link to="/promotions/jackpots">
                        <i className="bx bx-trending-up"></i>

                        {props.t("Jackpots")}
                      </Link>
                    </li>
                  )}

                  {hasPermission("read-acca7") && (
                    <li>
                      <Link to="/promotions/acca7">
                        <i className="bx bx-trending-up"></i>

                        {props.t("Acca7")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-freebets") && (
                    <li>
                      <Link to="/promotions/Freespin">
                        <i className="bx bx-trending-up"></i>

                        {props.t("Freebets")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-autometedfreespin") && (
                    <li>
                      <Link to="/promotions/AutometedFreeSpin">
                        <i className="bx bx-trending-up"></i>

                        {props.t("AutometedFreeSpin")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {(hasPermission("access-accounting-menu") ||
              hasPermission("access-reports-menu") ||
              hasPermission("access-promotions-menu")) && (
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-star"></i>
                  <span>{props.t("Affiliate")}</span>
                </Link>

                <ul className="sub-menu" aria-expanded="false">
                  {hasPermission("read-customers-report") && (
                    <li>
                      <Link to="/affiliate/dashboard">
                        <i className="bx bx-folder"></i>
                        {props.t("Dashboard")}
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link to="/affiliate/bonus-configuration">
                      <i className="bx bx-star"></i>

                      {props.t("Bonus Configuration")}
                    </Link>
                  </li>
                  {hasPermission("read-withdrawals") && (
                    <li>
                      <Link to="/affiliate/withdrawal-report">
                        <i className="bx bx-receipt"></i>

                        {props.t("Withdrawal Report")}
                      </Link>
                    </li>
                  )}
                  {hasPermission("read-parameters") && (
                    <li>
                      <Link to="/affiliate/parameters">
                        <i className="bx bx-cog"></i>

                        {props.t("Parameters / Settings")}
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(SidebarContent))
